<template>
    <div class="zvit">
            <b-overlay
                :show="busy"
                rounded
                opacity="0.6"
                spinner
                spinner-variant="bruvis"
            >

                <b-form-select
                    v-if="salepoints && salepoints.length > 1"
                    v-model="slpnt"
                    :options="salepoints"
                    class="mb-2 shadow-none"
                    value-field="rn"
                    text-field="posname"
                    @change = "setManager()"
                ></b-form-select>


                    <b-tabs fill content-class="p-0 m-0 mt-3 text-center">
                        <b-tab title="За день" active>

                                <v-date-picker
                                    v-model="oneday"
                                    mode="date"
                                    masks="YYYY-MM-DD" 
                                    :locale="{ id: 'uk', firstDayOfWeek: 2, masks: { weekdays: 'WW' } }"
                                    :max-page="{year: (new Date()).getFullYear(), month: (new Date()).getMonth()+1}"
                                    style="margin:0 auto"
                                ></v-date-picker>

                                <div v-if="manager==='true'" style="margin:10px auto" class="text-left">
                                    <!--b-form-checkbox
                                        id="checkbox-1"
                                        v-model="onlyme"
                                        name="onlyme"
                                    >Тільки для мене</b-form-checkbox-->

                                    <b-form-group v-slot="{ ariaDescribedby }" class="mx-3">
                                        <b-form-radio v-model="onlyme" :aria-describedby="ariaDescribedby" value=false>По всіх користувачах</b-form-radio>
                                        <b-form-radio v-model="onlyme" :aria-describedby="ariaDescribedby" value=true>Тільки для мене</b-form-radio>
                                    </b-form-group>

                                    <b-form-group v-slot="{ ariaDescribedby }"  class="mx-3"> <!--label="Формат звіту" -->
                                        <b-form-radio v-model="format" :aria-describedby="ariaDescribedby" value="pdf">PDF</b-form-radio>
                                        <b-form-radio v-model="format" :aria-describedby="ariaDescribedby" value="xls">XLS</b-form-radio>
                                        <!--b-form-radio v-model="format" :aria-describedby="ariaDescribedby" value="txt">TXT</b-form-radio-->
                                    </b-form-group>

                                </div>    
                                
                                <b-button class="mt-2 w-100" variant="bruvis" @click="downloadZvit(1, oneday, null)">Друк всіх замовлень на день</b-button>


                        </b-tab>
                        <b-tab title="За період">

                                        <v-date-picker
                                            v-model="range"
                                            mode="date"
                                            masks="YYYY-MM-DD" 
                                            is-range
                                            :locale="{ id: 'uk', firstDayOfWeek: 2, masks: { weekdays: 'WW' } }"
                                            :max-page="{year: (new Date()).getFullYear(), month: (new Date()).getMonth()+2}"
                                            style="margin:0 auto"
                                        ></v-date-picker>

                                        <div v-if="manager==='true'" style="margin:10px auto"  class="text-left">
                                            <!--b-form-checkbox
                                                id="checkbox-1"
                                                v-model="onlyme"
                                                name="onlyme"
                                            >Тільки для мене</b-form-checkbox-->

                                            <b-form-group v-slot="{ ariaDescribedby }"  class="mx-3">
                                                <b-form-radio v-model="onlyme" :aria-describedby="ariaDescribedby" value=false>По всіх користувачах</b-form-radio>
                                                <b-form-radio v-model="onlyme" :aria-describedby="ariaDescribedby" value=true>Тільки     для мене</b-form-radio>
                                            </b-form-group>

                                            <b-form-group v-slot="{ ariaDescribedby }"   class="mx-3">
                                                <b-form-radio v-model="format" :aria-describedby="ariaDescribedby" value="pdf">PDF</b-form-radio>
                                                <b-form-radio v-model="format" :aria-describedby="ariaDescribedby" value="xls">XLS</b-form-radio>
                                                <!--b-form-radio v-model="format" :aria-describedby="ariaDescribedby" value="txt">TXT</b-form-radio-->
                                            </b-form-group>
                                        </div>    

                                        <b-button variant="bruvis" class="mt-2 w-100" @click="downloadZvit(2, range.start, range.end)">Друк всіх замовлень на період</b-button>
                                        <b-button variant="bruvis" class="mt-2 w-100" @click="downloadZvit(3, range.start, range.end)">Друк всіх рахунків на період</b-button>

                        </b-tab>
                    </b-tabs>

            </b-overlay>
        </div>            
            <!--div v-if="dt && dt.id && zakazy_payed[dt.id]">
                <pre>{{zakazy_payed[dt.id]}}</pre>
            </div-->    

<!--  date-picker   v-model = "dt"
:attributes ="{ highlight:{color: 'blue',fillMode: 'light'},color: 'red'}"

-->
        <!--div>{{dt}}</div>
        <div><pre>{{days_payed}}</pre></div>
        <div><pre>{{zakazy_payed}}</pre></div-->


</template>

<script>

export default {
  name: 'ZvitPrint',
  props: {
    salepoint: {
      type: Object,
      required: true
    },
    salepoints: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    busy: false,
    range: {
        start: new Date(),
        end: new Date()
    },
    oneday: new Date(),
    slpnt: null,
    format: "pdf",
    masks: {
        input: 'YYYY-MM-DD',
    },
    onlyme: false,
    manager: false
    
  }),  
  methods: {

    downloadZvit(mode, datefr, dateto){

        this.busy = true

        var axiosConfig = {
            'withCredentials': true,
            'responseType': 'blob'
        }
        var FILE

      this.$axios.post('', {"action":"zvit","mode": mode, "datefr":this.dateFormat(datefr), "dateto":this.dateFormat(dateto), 'salepoint' : this.slpnt, 'onlyme' : this.onlyme, 'format' : this.format}, axiosConfig )
        .then((res) => {
            this.busy = false  

            const contentType = res.headers['content-type']

            if (contentType && contentType.includes('application/'+this.format)) {
                switch (this.format) {
                    case 'pdf':
                        FILE = window.URL.createObjectURL(new Blob([res.data], { type: 'application/'+this.format }));
                        window.open(FILE)
                        break 
                    case 'xls':    
                    case 'txt':                    
                        FILE = window.URL.createObjectURL(new Blob([res.data]));
                        var docUrl = document.createElement('a');
                        docUrl.href = FILE;
                        docUrl.setAttribute('download', 'report_'+this.dateFormat(datefr)+'_'+this.dateFormat(dateto)+'.'+this.format);
                        document.body.appendChild(docUrl);
                        docUrl.click(); 
                }        
            }else{
                const reader = new FileReader();
                reader.onload = () => {
                    const text = reader.result;
                    const obj = JSON.parse(text);

                    if (obj.error == 'auth'  || obj.error == 'init') {
                        this.$emit('needlogin')
                    }
                }
                reader.readAsText(res.data)
            }
                /*
                res.data.text().then(text => {
                    const errorData = JSON.parse(text);
                    if (errorData.errortype === 'auth'  || errorData.error == 'init') {
                            this.$emit('needlogin')
                    return;
                    }
                });
                */
/*                
                const text = res.data.text();
console.log('text',text)                
                const errorData = JSON.parse(text);
console.log('errordata',errorData)                                
*/
/*
                if (errorData.error == 'auth' || errorData.error == 'init') {
                    this.$emit('needlogin')
                    return;
                }
*/                
            //}
/*
            switch (this.format) {
                case 'pdf':
                    FILE = window.URL.createObjectURL(new Blob([res.data], { type: 'application/'+this.format }));
                    window.open(FILE)
                    break 
                case 'xls':    
                case 'txt':                    
                    FILE = window.URL.createObjectURL(new Blob([res.data]));
                    var docUrl = document.createElement('a');
                    docUrl.href = FILE;
                    docUrl.setAttribute('download', 'report_'+this.dateFormat(datefr)+'_'+this.dateFormat(dateto)+'.'+this.format);
                    document.body.appendChild(docUrl);
                    docUrl.click(); 
            }        
*/                    

/*
          if(res.data.success != false && res.data.success != 'false'){
            switch (this.format) {
                case 'pdf':
                    FILE = window.URL.createObjectURL(new Blob([res.data], { type: 'application/'+this.format }));
                    window.open(FILE)
                    break 
                case 'xls':    
                case 'txt':                    
                    FILE = window.URL.createObjectURL(new Blob([res.data]));
                    var docUrl = document.createElement('a');
                    docUrl.href = FILE;
                    docUrl.setAttribute('download', 'report_'+this.dateFormat(datefr)+'_'+this.dateFormat(dateto)+'.'+this.format);
                    document.body.appendChild(docUrl);
                    docUrl.click(); 
            }        
*/                    
            /*
            var FILE = window.URL.createObjectURL(new Blob([res.data]));
            var docUrl = document.createElement('a');
            docUrl.href = FILE;
            docUrl.setAttribute('download', 'ticket_'+fl+'.pdf');
            document.body.appendChild(docUrl);
            docUrl.click(); 
            ////document.body.removeChild(docUrl);
            ////window.URL.revokeObjectURL(FILE);
            */
            //var FILE = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
            //window.open(FILE)
/*            
          }else{
            if(res.data.error=="init" || res.data.error=="auth"){
              this.$emit('needlogin')
            }
          } 
*/          
        })
        .catch(error => {
          console.error('There was an error!', error)
        });
    },

    dateFormat(dt){
        if(!dt) return null
        //dt = new Date(dt)
        const year = dt.getFullYear()
        const month = (dt.getMonth() + 1).toString().padStart(2, '0'); 
        const day = dt.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    },

    setManager(){
        this.manager = this.salepoints[this.salepoints.map((item)=>item.rn).indexOf(this.slpnt)].manager
    }


    /*
        getArchiveMonth(m, y){
            this.busy = true;
            this.$axios.post('', {"action":"getarchive","m":m,"y":y } )
                .then((response) => {
                if(response.data.success != false && response.data.success != 'false'){
                    this.zakazy_payed = response.data.zakazy_payed
                    this.days_payed = response.data.days_payed
                    this.gotoDateIndex(this.days_payed.length-1)
                    this.busy = false;

                    //const calendar = this.$refs.calendar
                    //calendar.attributes =  this.getAttributes()

                    //console.log(this.getAttributes())
                    //console.log(calendar)

                    //this.$refs.calendar.attributes.available-dates = this.archive.days_payed
                    //this.$toasted.success(response.data.message).goAway(3000)
                    //this.ordersbusy = false
                }else{

                    this.busy = false;
                    if(response.data.error=="auth" || response.data.error=="tokenout"){
                        //this.needlogin = true
                        this.$emit('needlogin')
                    }else{
                        this.$toasted.error(response.data.message).goAway(3000) 
                    }
                }  
                })
                .catch(error => {
                    this.busy = false
                    console.error('There was an error!', error)
                });
        },
        dayClicked(day){
            if(day.isDisabled) return false
            this.dt = day
            this.zakazy_day = this.zakazy_payed[day.id]
            this.dt_index = this.days_payed.indexOf(day.id)
            this.dt_label = day.ariaLabel
            this.dt_id = day.id
            
        },
        gotoDateIndex(idx){
            this.dt_id = this.days_payed[idx]
            this.zakazy_day = this.zakazy_payed[this.dt_id]
            this.dt_index = idx
            

        },
        getAttributes(){
            return this.days_payed.map( d => ({
                    dates: new Date(d),
                    highlight:{
                        color: 'blue',
                        fillMode: 'light'
                    },
                    color: 'red'
                }))
                
            
        }*/
    
  },
  
  mounted() {
    //this.slpnt = (this.manager.map((itm)=>itm.rn).indexOf(this.salepoint.rn)!=-1)?this.salepoint.rn:this.manager[0].rn
    this.slpnt = this.salepoint.rn
    this.manager = this.salepoint.manager
  },
  beforeMount() {
    const d = new Date()
    const day = d.getDay() // 0 (Воскресенье) - 6 (Суббота)
  
    const diff = d.getDate() - (day === 0 ? 6 : day - 1)
  
    // Первый день недели (Понедельник)
    const firstDay = new Date(d.setDate(diff))
    firstDay.setHours(0, 0, 0, 0) // Устанавливаем начало дня

    // Последний день недели (Воскресенье)
    const lastDay = new Date(d.setDate(diff + 6))
    lastDay.setHours(23, 59, 59, 999) // Устанавливаем конец дня

    this.range.start = firstDay
    this.range.end = lastDay
  },

    computed: {
        managerparam(){
            return {
                "salepoint" : this.slpnt,
                "onlyme"    : (this.manager==='true')?this.onlyme:null,
                "format"    : (this.manager==='true')?this.format:null
            }
        },
        
        /*
        availDates(){
            return this.days_payed.map(d => new Date(d))
        },
        attrs(){
            //return this.days_payed.map(d => ({dates: new Date(d), highlight: true}))
            return this.days_payed.map(d => ({
                dates: new Date(d), 
                highlight: {
                    color: 'gray',
                    fillMode: 'solid'
                }
            }))
        },
        */
        /*
        minPage(){
            return {
                min-page [
                    
                        year: (new Date(this.zakazy_days[0])).getFullYear(), 
                        month: (new Date(this.zakazy_days[0])).getMonth()
                        
                ]
            }    
        }
        */
        
    }
}
</script>

<style scoped>


@media (max-width: 575px) {
  

}

@media (hover: none) {


}    



</style>
